module.exports = __webpack_public_path__ + "img/mother-of-thousands-1.930d06f8.jpg";